import bookingShiftApi from "../../apis/liff/v2/booking-shift"
import moment from "moment"

// test: jest src/utils/booking/__tests__/BookingShift.test.js
export default class BookingShift {
  constructor() {
    this._shifts = []
    this.isFetchingShifts = false
  }

  async fetch(bookingPresetId, branchId, startAt, endAt) {
    this.isFetchingShifts = true
    try {
      this._shifts = await bookingShiftApi.get({
        booking_preset_id: bookingPresetId,
        branch_id: branchId,
        start_at: startAt,
        end_at: endAt,
      }) || []
    } catch (error) {
      this._shifts = []
      throw error
    } finally {
      this.isFetchingShifts = false
    }
  }

  isTotallyOffDutyBetween(startAt, endAt) {
    return this._shifts.some(shift => {
      return moment(shift.start_at).isSameOrBefore(moment(startAt)) &&
        moment(shift.end_at).isSameOrAfter(moment(endAt))
    })
  }

  isPartiallyOffDutyBetween(startAt, endAt) {
    return this._shifts.some(shift => {
      return moment(shift.start_at).isSameOrBefore(moment(endAt)) &&
        moment(shift.end_at).isSameOrAfter(moment(startAt))
    })
  }
}
